import clsx from 'clsx'

export const historyTableStyles = {
  table:
    'w-full min-w-[820px] table-auto text-[0.65rem] sm:text-[0.725rem] border-collapse leading-tight font-sans',
  thead: 'sticky top-0 z-10 bg-white',
  th: 'py-2 px-1 sm:px-2 w-auto max-w-[180px] text-center break-words border-b border-gray-200 uppercase text-[0.55rem] sm:text-[0.6rem] font-bold text-gray-500',
  tr: 'border-b border-gray-100 hover:bg-gray-50 transition-colors',
  td: 'py-2 px-1 sm:px-2 w-auto max-w-[240px] text-center break-words align-middle',
  boldText: 'font-bold text-[0.62rem] sm:text-[0.65rem]',
  text: 'text-[0.65rem] sm:text-[0.705rem] text-gray-400 font-medium'
}

const normalizeStatus = status =>
  String(status || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/_/g, ' ')
    .trim()
    .toUpperCase()

const statusBadgeBase =
  'inline-flex items-center justify-center rounded-full px-3 py-1 text-[0.6rem] sm:text-[0.65rem] font-semibold uppercase tracking-wider leading-tight'

export const getStatusBadgeClass = tone =>
  clsx(statusBadgeBase, {
    'text-danger bg-danger/10': tone === 'danger',
    'text-success bg-success/10': tone === 'success',
    'text-amber-700 bg-amber-100': tone === 'warning',
    'text-muted bg-border/40': tone === 'muted'
  })

const includesSome = (value, terms) => terms.some(term => value.includes(term))

export const getPaymentStatusMeta = payment => {
  const normalized = normalizeStatus(
    payment?.status ?? payment?.metadata?.status ?? payment?.paymentStatus ?? ''
  )

  if (!normalized) {
    return { label: '-', tone: 'muted' }
  }

  if (
    includesSome(normalized, [
      'PAID',
      'PAGADO',
      'APPROVED',
      'APROBADO',
      'AUTHORIZED',
      'AUTORIZADO',
      'SUCCESS',
      'SETTLED',
      'ACCREDITED'
    ])
  ) {
    return { label: 'PAGADO', tone: 'success' }
  }

  if (
    includesSome(normalized, [
      'PENDING',
      'PENDIENTE',
      'IN PROCESS',
      'INPROCESS',
      'PROCESSING',
      'REVIEW',
      'REVISION',
      'MANUAL REVIEW'
    ])
  ) {
    return { label: 'EN REVISION', tone: 'warning' }
  }

  if (includesSome(normalized, ['REFUNDED', 'REEMBOLSADO'])) {
    return { label: 'REEMBOLSADO', tone: 'muted' }
  }

  if (includesSome(normalized, ['CANCELLED', 'CANCELED', 'CANCELADO'])) {
    return { label: 'CANCELADO', tone: 'danger' }
  }

  if (includesSome(normalized, ['REJECTED', 'RECHAZADO', 'FAILED', 'DENIED', 'REFUSED'])) {
    return { label: 'RECHAZADO', tone: 'danger' }
  }

  return { label: normalized, tone: 'muted' }
}

export const getSubscriptionStatusMeta = subscription => {
  const now = new Date()
  const startDate = subscription?.startDate ? new Date(subscription.startDate) : null
  const endDate = subscription?.endDate ? new Date(subscription.endDate) : null
  const normalized = normalizeStatus(subscription?.metadata?.status ?? subscription?.status ?? '')

  if (subscription?.isCancelled || includesSome(normalized, ['CANCELLED', 'CANCELED', 'CANCELADA', 'CANCELADO'])) {
    return { label: 'CANCELADA', tone: 'danger' }
  }

  if (subscription?.isActive) {
    return { label: 'ACTIVA', tone: 'success' }
  }

  if (startDate && startDate > now) {
    return { label: 'FUTURA', tone: 'warning' }
  }

  if (includesSome(normalized, ['PAUSED', 'PAUSADA', 'PAUSADO'])) {
    return { label: 'PAUSADA', tone: 'muted' }
  }

  if (subscription?.isExpired || (endDate && endDate < now)) {
    return { label: 'VENCIDA', tone: 'muted' }
  }

  if (normalized) {
    return { label: normalized, tone: 'muted' }
  }

  return { label: 'INACTIVA', tone: 'muted' }
}
